import type { DraftEntityChanges } from '@repo/front-end-utils';

/** What an entity's lasting mark says changed: added in this draft, or moved in it. */
export type PlanEntityChange = 'added' | 'moved';

/**
 * **The spaces and machines the draft added or moved,** keyed by refid, for the Floor Plan's lasting
 * marks (`onboarding-status-colours-plan-spaces`, R6; `onboarding-status-colours-plan-machines`, R7).
 * Read from the page's one change source, so the plan marks what Versions counts.
 *
 * Spaces (the comparison's `zones` kind) and machines (`placedEquipment`): an added one is `added`,
 * whatever else it did; one that moved is `moved`. One only rezoned or renumbered has no lasting mark
 * here. Cameras and every other kind are left to their own steps.
 */
export const planEntityChanges = (
  byEntity: DraftEntityChanges,
): ReadonlyMap<string, PlanEntityChange> => {
  const changes = new Map<string, PlanEntityChange>();
  byEntity.forEach((change, refid) => {
    if (change.kind !== 'zones' && change.kind !== 'placedEquipment') return;
    if (change.added) changes.set(refid, 'added');
    else if (change.moved) changes.set(refid, 'moved');
  });
  return changes;
};
